import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "../../custom/Button.js";
import { Github, Mail } from "lucide-react";
import { strategyIcons, strategyLabels } from "../utils/signInUtils.js";
const fallbackIcons = {
    github: Github,
    email: Mail,
};
export function AuthButton({ strategy, onClick, isLoading, }) {
    const strategyIcon = strategyIcons[strategy];
    const strategyLabel = strategyLabels[strategy] || strategy;
    const FallbackIcon = fallbackIcons[strategy];
    const buttonLabel = `Sign in with ${strategyLabel}`;
    return (_jsx(Button, { onClick: onClick, disabled: isLoading, "aria-label": buttonLabel, title: buttonLabel, className: "flex w-full items-center justify-center bg-gray-100 px-2 py-3 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700", children: strategyIcon ? (_jsx("img", { src: strategyIcon, alt: `${strategyLabel} icon`, className: "h-9 w-9" })) : FallbackIcon ? (_jsx(FallbackIcon, { className: "h-9 w-9 text-gray-900 dark:text-gray-100" })) : (_jsx("span", { className: "text-sm font-semibold text-gray-900 dark:text-gray-100", children: strategyLabel.charAt(0) })) }, strategy));
}
